'use strict';

var flags = require('./flags.cjs');
var memo = require('../../../../../motion-utils/dist/es/memo.cjs');

function memoSupports(callback, supportsFlag) {
    const memoized = memo.memo(callback);
    return () => flags.supportsFlags[supportsFlag] ?? memoized();
}

exports.memoSupports = memoSupports;
//# sourceMappingURL=memo.cjs.map
